import { Grid } from '@mui/material'
import { AppBox, AppButton, AppTypography } from 'components'
import { appRoutes, ProfileModules } from 'globals/constants'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'store/app.store'
import { AuthSliceSelector, setOpenedProfileModule } from 'store/slices'

interface Props {}

export const TrialEndedMessage: FC<Props> = () => {
  const { CurrentUser } = useSelector(AuthSliceSelector)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleRedirect = () => {
    dispatch(setOpenedProfileModule(ProfileModules.Billing))
    navigate(appRoutes.profile.path)
  }
  return (
    <AppBox height={'91vh'} alignContent={'center'}>
      <Grid container justifyContent={'center'}>
        <Grid item xs={4}>
          <AppBox backgroundColor="white" borderRadius={6} border={1} borderColor={'grey.200'} padding={2}>
            <AppBox borderBottom={1} borderColor={'grey.200'} paddingBottom={1}>
              <AppTypography fontSize={32} fontWeight={'bold'}>
                {CurrentUser?.FirstName ?? ''}, your trial has ended
              </AppTypography>
            </AppBox>
            <AppTypography fontSize={16} fontWeight={400} color={'grey.500'} paddingTop={2}>
              Unfortunately, it looks like your <b>7-day free trial</b> has ended. No worries, we can get you back on
              track. Just head over to your <b>Billing & Plans</b> to add a payment method and then select a monthly or
              annual plan using the <b>Change Plan</b> button.
            </AppTypography>
            <AppBox textAlign={'right'} paddingTop={2}>
              <AppButton variant="contained" size="small" onClick={handleRedirect}>
                Billing & Plans
              </AppButton>
            </AppBox>
          </AppBox>
        </Grid>
        <Grid item xs={2}>
          <img
            src="/images/dashboard/old-subscription-cancelled/old-subscription-cancelled.png"
            alt="old-cancelled-message"
          />
        </Grid>
      </Grid>
    </AppBox>
  )
}
